const en = {
  meta: { title: "Trollfossjakten · The Troll Waterfall Quest — 84 trolls between Lavangen and Årstein" },
  sound: { mute: "Mute troll sounds", unmute: "Turn on troll sounds" },
  nav: { map: "Map", trolls: "Trolls", seasons: "Seasons", pricing: "Pricing", faq: "FAQ", getApp: "Get the app", hosts: "Become a host" },
  tagline: "61 trolls free forever. The rest are hiding — bring a pass.",
  store: { soon: "The app is almost out of the forest", soonBody: "Store links go live at launch — check back very soon.", appStore: "App Store", playStore: "Google Play", download: "Download on the", getIt: "Get it on" },
  hero: {
    kicker: "Lavangen · Gratangen · Troms",
    title: "Hunt 84 trolls between Lavangen and Årstein.",
    pitch: "9 waterfalls, 84 hand-crafted trolls and one fjord road. Free to start — works on skis in winter and on skates in summer.",
    cta: "Open the quest",
    ctaMap: "See the full map",
    stats: [["84", "trolls"], ["9", "waterfalls"], ["61", "free forever"], ["4", "seasons"]],
    stamp: "Free to start",
    photoNote: "Waterfalls · fjords · trolls",
  },
  what: {
    kicker: "What is Trollfossjakten?",
    title: "A folklore treasure hunt along a real fjord road.",
    cols: [
      { title: "Walk the trail", body: "Follow the road from Lavangen to Årstein on foot, bike, skis or skates. Nine waterfalls mark the way." },
      { title: "Capture trolls", body: "84 hand-crafted trolls hide by the streams, the shore and the shops. Find them, catch them, fill your journal." },
      { title: "Earn Troll Kroner", body: "Collect the in-app currency and spend it at partner cabins, cafés and shops along the route." },
    ],
    callout: "No registration needed. Open the app, start the hunt.",
  },
  map: {
    kicker: "The trail map",
    title: "Every troll, pinned.",
    body: "84 trolls spread along the road from Lavangen to Årstein, via Røkenes, Hestnes and Sørsida. Tap a pin to meet one — then catch it for real in the app.",
    chips: { all: "All", common: "Common", rare: "Rare", epic: "Epic", legendary: "Legendary", festivals: "Festivals", merchants: "Merchants" },
    showing: "trolls shown",
    start: "Lavangen · start",
    finish: "Årstein · finish",
    waterfall: "Waterfall",
    catchIt: "Catch it in the app",
    close: "Close",
    recenter: "Recenter",
  },
  xp: {
    kicker: "XP & game system",
    title: "Hunt, level up, brag a little.",
    body: "Every capture earns XP. Rarer trolls earn more — and some only show up when the calendar says so.",
    cards: {
      xp: { title: "XP per rarity", body: "The harder they hide, the more they pay." },
      ach: { title: "12 achievements", body: "Up to 5 000 XP each. A few to start with:", more: "+ 6 more to discover in the app" },
      items: { title: "Items & sets", body: "Collect trinkets the trolls leave behind and complete sets.", list: ["Pearls", "Runes", "Waffles", "Pirate gold"] },
      kroner: { title: "Troll Kroner", body: "Earned through referrals, the daily spin and merchant trolls. Spent at partner cabins and merchants." },
    },
    achievements: [["First Capture", 20], ["Festival Fan", 500], ["Stream King", 800], ["Lone Warrior", 1000], ["Legendary Hunter", 1500], ["Season Loop", 5000]],
    extras: [
      { title: "Streaks + Streak Shield", body: "Hunt daily to grow your streak. The shield saves one missed day per week." },
      { title: "Daily spin", body: "A weighted roulette with 3 tiers. One spin every 24 hours." },
      { title: "Passes", body: "Epic Pass or Rare Pass, valid 365 days from activation. Person, family, team and bus-group tiers." },
      { title: "Special trolls", body: "2 weekend-only trolls (Fri–Sun), 10 festival-only trolls, 6 merchant trolls at local businesses and 5 promo trolls." },
    ],
  },
  gallery: {
    kicker: "The troll journal",
    title: "Meet all 84.",
    body: "Every troll has a name, a nickname and a habit. Tap a card to read its journal entry.",
    chips: { all: "All", common: "Common", rare: "Rare", epic: "Epic", legendary: "Legendary", festivals: "Festivals", merchants: "Merchants", weekend: "Weekend", promo: "Promo" },
    more: "Show more trolls",
    count: "of 84",
    portraitNote: "The rest are hiding — find them in the app.",
    hidden: "still hiding",
    hiding: "Hiding",
  },
  journal: {
    entry: "Journal entry",
    where: "Where",
    waterfall: "Waterfall",
    xp: "XP",
    access: "Unlock",
    window: "Appears",
    weekend: "Fridays to Sundays only",
    liveNow: "Out now",
    catchIt: "Catch it in the app",
  },
  access: { free: "Free forever", epic_pass: "Epic Pass", rare_pass: "Rare Pass" },
  rarity: { common: "Common", rare: "Rare", epic: "Epic", legendary: "Legendary" },
  category: { stream: "Stream troll", intro: "Intro guide", merchant: "Merchant troll", promo: "Promo troll", weekend: "Weekend troll", festival_sami: "Sámi festival troll", festival_norwegian: "Norwegian festival troll" },
  specials: {
    kicker: "Special trolls",
    title: "19 specials — and 5 promo trolls on top.",
    body: "Some trolls keep their own calendar. Festival trolls appear only on the real festival dates.",
    flavours: [
      { key: "intro", count: 1, title: "Intro guide", body: "Your first troll in Lavangen — shows you how the hunt works." },
      { key: "festival_sami", count: 4, title: "Sámi festival trolls", body: "Sámi National Day, Riddu Riđđu and Márkomeannu." },
      { key: "festival_norwegian", count: 6, title: "Norwegian festival trolls", body: "From 17 May to the polar night." },
      { key: "weekend", count: 2, title: "Weekend trolls", body: "Out Friday to Sunday only." },
      { key: "merchant", count: 6, title: "Merchant trolls", body: "Living at real local businesses on the route." },
      { key: "promo", count: 5, title: "Promo trolls", body: "Unlocked by referrals, posters and promo codes." },
    ],
    calendar: "Festival calendar",
    next: "Next window",
    liveNow: "Out now",
  },
  festivals: {
    "Sámi National Day": "Sámi National Day", "Riddu Riđđu": "Riddu Riđđu", "Márkomeannu": "Márkomeannu",
    "Constitution Day": "Constitution Day", "Midsummer": "Midsummer", "Lussinatta": "Lussinatta",
    "Christmas": "Christmas", "Midnight Sun": "Midnight Sun", "Polar Night": "Polar Night",
  },
  seasons: {
    kicker: "Four seasons",
    title: "One trail, four very different moods.",
    standout: "Standout troll",
    tabs: {
      winter: { name: "Winter", title: "Skis under the aurora", body: "Glide the route on cross-country skis while the northern lights dance over the fjord. Headlamp on, thermos full." },
      spring: { name: "Spring", title: "Reindeer Easter", body: "Long, bright days, crisp snow and reindeer on the move. Perfect for families on the gentle sections." },
      summer: { name: "Summer", title: "Midnight-sun bonfires", body: "Rollerblade the smooth stretches, let the kids race ahead on bikes, then light a bonfire when the sun refuses to set." },
      autumn: { name: "Autumn", title: "Mushroom hikes", body: "Golden birches, blueberries and chanterelles. Grandparents love the gentle sections — so do the trolls." },
    },
  },
  merchants: {
    kicker: "Local businesses",
    title: "Merchant trolls live at real local spots.",
    body: "Six trolls live at cabins, cafés, shops and rentals along the route. Find them for free and spend your Troll Kroner there.",
    partnerSoon: "Partner revealed at launch",
    spend: "Spend Troll Kroner here",
    types: { "Cabin rental": "Cabin rental", "Farm shop": "Farm shop", "Café": "Café", "Kayak rental": "Kayak rental", "Bakery": "Bakery", "Grocer · finish line": "Grocer · finish line" },
  },
  pricing: {
    kicker: "Pricing",
    title: "Start free. Bring a pass for the rest.",
    launch: "Launch pricing · 50% off through the 2026 season",
    tiers: { person: "Person", family: "Family", team: "Team", bus: "Bus group" },
    days: "365 days from activation",
    free: { name: "Free", price: "0 kr", line: "61 trolls free forever", body: "No registration needed.", perks: ["All common & rare stream trolls", "All 6 merchant trolls", "The intro guide + 5 promo trolls"], cta: "Start free" },
    epic: { name: "Epic Pass", line: "Unlocks epic + legendary trolls", perks: ["Every epic & legendary stream troll", "Both weekend trolls"], cta: "Get the Epic Pass" },
    rare: { name: "Rare Pass", line: "Unlocks every troll — festivals and legendary included", perks: ["All 84 trolls", "All 10 festival trolls", "Everything in the Epic Pass"], cta: "Get the Rare Pass", ribbon: "All 84 trolls" },
    note: "Passes are bought in the app. Launch pricing is time-limited.",
    was: "was",
  },
  faq: {
    kicker: "FAQ",
    title: "Questions from the trailhead.",
    items: [
      ["Do I need to register?", "No. Download the app, open it and start hunting. 61 trolls are free forever."],
      ["Is there mobile signal on the trail?", "Coverage along the road is generally good, but it can dip in a few spots in the valleys. Charge your phone and note the emergency numbers before you set out."],
      ["Can I use it in winter?", "Yes. The trolls are out all year. Bring skis or spikes, a headlamp for the polar night, and check road conditions before you go."],
      ["Is it good for kids?", "Yes. Many trolls sit close to the road and the gentle sections suit small legs, bikes and prams. Parts of the route follow public roads, so keep an eye on traffic."],
      ["Where do I park, and how do I get back?", "Start in Lavangen or Årstein. Regional buses serve parts of the route — check the local timetable before you go."],
      ["What is a merchant troll?", "A troll that lives at a real local business on the route — a cabin, café or shop. It is free to catch, and you can spend Troll Kroner there."],
      ["What are Troll Kroner?", "The in-app currency. Earn it through referrals, the daily spin and merchant trolls, and spend it at partner cabins and merchants."],
      ["How accurate are the festival dates?", "Festival trolls appear only within the real festival dates. If a festival moves its dates, the troll moves with it."],
      ["How long does a pass last?", "Epic and Rare Passes last 365 days from the day you activate them, with person, family, team and bus-group tiers."],
      ["What about my privacy?", "You can play without an account. The app uses your location to show nearby trolls while you play. This website asks for nothing."],
    ],
  },
  install: { title: "Trollfossjakten", body: "61 trolls free forever", cta: "Get the app", dismiss: "Dismiss install bar" },
  footer: { supporter: "Become a supporter", about: "About", press: "Press", privacy: "Privacy", terms: "Terms", contact: "Contact", follow: "Follow the hunt", soon: "Coming at launch", country: "Norway", supportedBy: "Supported by" },
  logoAlt: "Trollfossjakten logo",
  langSwitch: "Language",
  a11y: { menu: "Menu", footer: "Footer", zoomIn: "Zoom in", zoomOut: "Zoom out", notifications: "Notifications" },
  sos: "Emergency info",
  emergency: {
    back: "Back",
    title: "Emergency",
    alert: "If you are in danger, call your local emergency number immediately.",
    h1: "SOS — quick help, anywhere on the trail.",
    intro: "Tap a number to call. Share your live location with an optional photo and message to family, friends or rescue services.",
    step: "Step {n}",
    country: "Your country",
    search: "Search country…",
    noMatch: "No country matches",
    callNow: "Call now —",
    all: "All emergencies",
    police: "Police",
    fire: "Fire",
    ambulance: "Ambulance",
    locTitle: "Send your live location",
    detect: "Detect my location",
    locating: "Locating…",
    refresh: "Refresh location",
    noGeo: "Your browser does not support location.",
    locFail: "Unable to get your location.",
    near: "Near",
    openMaps: "Open in Google Maps ↗",
    msgLabel: "Add a message (optional)",
    msgPh: "E.g. I twisted my ankle near the second waterfall. Bring water and a first-aid kit.",
    photoLabel: "Attach a photo (optional)",
    choose: "Choose photo",
    change: "Change photo",
    remove: "Remove",
    previewAlt: "Attached photo",
    send: "Send emergency location",
    copy: "Copy",
    shared: "Shared from your device.",
    shareFail: "Could not open the share menu. Try Copy instead.",
    copied: "Copied.",
    copyFail: "Copy failed.",
    privacy: "Sharing uses your phone's own share menu (SMS, WhatsApp, e-mail and so on). Nothing is sent through our servers. In a real emergency, always call the number above too.",
    backTrail: "Back to the trail",
    msgHead: "🆘 EMERGENCY — I need help.",
    mapLabel: "Map",
    timeLabel: "Time",
    shareTitle: "Emergency — Trollfossjakten",
    notes: {
      NO: "112 is the European emergency number. 110 reaches fire and 113 reaches medical help directly.",
      SE: "One emergency number, 112, for all services.",
      FI: "112 reaches police, fire and ambulance.",
      DK: "112 for emergencies, 114 for non-urgent police.",
      IS: "One number nationwide: 112.",
      DE: "110 for police, 112 for fire and ambulance.",
      FR: "17 police, 18 fire, 15 ambulance (SAMU). 112 also works.",
      GB: "999 (or 112) for all emergencies. 101 for non-urgent police.",
      IE: "Both 112 and 999 work.",
      NL: "112 for emergencies, 0900-8844 for non-urgent police.",
      ES: "112 covers everything. National Police 091, local police 092.",
      IT: "112 for all emergencies, 113 state police.",
      PL: "112 reaches all services.",
      US: "Dial 911 for any emergency. 311 for non-emergencies in many cities.",
      CA: "911 nationwide for all emergencies.",
      AU: "Triple Zero (000). 112 also works on mobile phones.",
      NZ: "111 nationwide. 105 for non-urgent police.",
      CN: "110 police, 119 fire, 120 ambulance. 122 for traffic accidents.",
      RU: "112 reaches all services. 102 police, 101 fire, 103 ambulance.",
      TH: "191 police, 199 fire, 1669 ambulance. Tourist Police 1155 (English spoken).",
    },
  },
};

export default en;
